import { createAction, createAsyncAction, FULFILLED, PENDING, REJECTED } from '../utils'
import { selectTeam } from '../selectors/teamSelectors'
import { getTeamApi, updateTeamPlanApi } from '../../services/team'
import { enqueueSnackbar } from './snackbar'

// ------------------------------------
// Action Types & Creators
// ------------------------------------
export const STATE_RESET = 'foodsby/team/teamAddOns/STATE_RESET'
export const TEAM_SUBSCRIPTION_SET = 'foodsby/team/teamAddOns/TEAM_SUBSCRIPTION_SET'
export const TEAM_SUBSCRIPTION_UPDATE = 'foodsby/team/teamAddOns/TEAM_SUBSCRIPTION_UPDATE'

export const resetState = createAction(STATE_RESET)
export const setTeamSubscription = createAsyncAction(TEAM_SUBSCRIPTION_SET)
export const setTeamSubscriptionPending = createAction(PENDING(TEAM_SUBSCRIPTION_SET))
export const setTeamSubscriptionFulfilled = createAction(FULFILLED(TEAM_SUBSCRIPTION_SET))
export const setTeamSubscriptionRejected = createAction(REJECTED(TEAM_SUBSCRIPTION_SET))

export const updateTeamSubscription = createAsyncAction(TEAM_SUBSCRIPTION_UPDATE)

// ------------------------------------
// Thunks
// ------------------------------------
export const loadTeamSubscriptionStart = teamId => {
  return dispatch => {
    // for now we are using the plan information from `team` module so load that
    return dispatch(setTeamSubscription(getTeamApi(teamId)))
  }
}

export const subscribeStart = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const team = selectTeam(state)

    try {
      await dispatch(updateTeamSubscription(updateTeamPlanApi(team.id, { planId: 2 })))
    } catch (ex) {
      return dispatch(
        enqueueSnackbar({ message: 'Something went wrong while updating the add-on.' }), // TODO Update this message
      )
    }
  }
}

export const unsubscribeStart = () => {
  return async (dispatch, getState) => {
    const state = getState()
    const team = selectTeam(state)
    try {
      await dispatch(updateTeamSubscription(updateTeamPlanApi(team.id, { planId: 1 })))
    } catch (ex) {
      return dispatch(
        enqueueSnackbar({ message: 'Something went wrong while updating the add-on.' }), // TODO Update this message
      )
    }
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [STATE_RESET]: () => {
    return initialState
  },
  [FULFILLED(TEAM_SUBSCRIPTION_SET)]: (state, action) => {
    return {
      ...state,
      teamSubscription: action.payload?.plan,
      isLoadingSubscription: false,
    }
  },
  [PENDING(TEAM_SUBSCRIPTION_UPDATE)]: state => {
    return {
      ...state,
      isUpdatingSubscription: true,
      successUpdatingSubscription: false,
    }
  },
  [FULFILLED(TEAM_SUBSCRIPTION_UPDATE)]: state => {
    return {
      ...state,
      isUpdatingSubscription: false,
      successUpdatingSubscription: true,
    }
  },
  [REJECTED(TEAM_SUBSCRIPTION_UPDATE)]: state => {
    return {
      ...state,
      isCreatingPaymentMethod: false,
      successUpdatingSubscription: false,
    }
  },
}

export const initialState = {
  teamSubscription: undefined,
  // Loading states
  isLoadingSubscription: true,
  isUpdatingSubscription: false,
  // Success states
  successUpdatingSubscription: false,
  // Error states
}

export default function teamAddOns(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}
